module.exports = __webpack_public_path__ + "img/emojione_glowing-star.f48c8790.svg";